<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Ingresa tu fórmula</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <formula-form @close="selectedFormula"></formula-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import FormulaForm from '@/components/Formula/FormulaForm'

export default {
  name: 'FormulaModal',
  components: {
    FormulaForm
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    openModal () {
      this.isOpen = true
    },
    closeModal () {
      this.isOpen = false
    },
    selectedFormula (data) {
      this.$emit('selectedFormula', data)
      this.closeModal()
    }
  }
}
</script>

<style scoped>
  .light-text{
    font-size: 13px;
    color: #666;
    opacity: 0.7;
    line-height: 20px;
  }
</style>
